var map = {
	"./activities/elections/election_post/da.yml": 70435,
	"./activities/elections/election_post/en.yml": 38928,
	"./activities/index/card/da.yml": 12329,
	"./activities/index/card/description/da.yml": 11124,
	"./activities/index/card/description/en.yml": 17788,
	"./activities/index/card/en.yml": 4365,
	"./activities/index/da.yml": 33394,
	"./activities/index/en.yml": 89438,
	"./activities/link_cards/index/da.yml": 54741,
	"./activities/link_cards/index/en.yml": 42625,
	"./activities/register_button/da.yml": 95920,
	"./activities/register_button/en.yml": 94832,
	"./activities/regret_unregister_button/da.yml": 59019,
	"./activities/regret_unregister_button/en.yml": 77051,
	"./activities/show/da.yml": 66527,
	"./activities/show/en.yml": 74999,
	"./activities/show/politics/da.yml": 32519,
	"./activities/show/politics/en.yml": 44111,
	"./admin/abilities/table/da.yml": 36385,
	"./admin/abilities/table/en.yml": 89397,
	"./admin/ability_group_abilities/lock_icon/da.yml": 46905,
	"./admin/ability_group_abilities/lock_icon/en.yml": 61341,
	"./admin/ability_groups/edit/da.yml": 9760,
	"./admin/ability_groups/edit/en.yml": 64256,
	"./admin/ability_groups/table/da.yml": 23296,
	"./admin/ability_groups/table/en.yml": 27104,
	"./admin/activities/activities_nav/da.yml": 58169,
	"./admin/activities/activities_nav/en.yml": 31485,
	"./admin/activities/billing/da.yml": 32921,
	"./admin/activities/billing/en.yml": 71485,
	"./admin/activities/children/da.yml": 45421,
	"./admin/activities/children/en.yml": 9001,
	"./admin/activities/create_card/expandable_content/da.yml": 21236,
	"./admin/activities/create_card/expandable_content/en.yml": 4604,
	"./admin/activities/create_card/surveys_card/da.yml": 72136,
	"./admin/activities/create_card/surveys_card/en.yml": 96184,
	"./admin/activities/edit/da.yml": 12290,
	"./admin/activities/edit/en.yml": 40846,
	"./admin/activities/index/da.yml": 60986,
	"./admin/activities/index/en.yml": 15670,
	"./admin/activities/live/agenda/item_types/election/election_post/da.yml": 74669,
	"./admin/activities/live/agenda/item_types/election/election_post/en.yml": 51734,
	"./admin/activities/live/agenda/item_types/election/election_post_card/da.yml": 39265,
	"./admin/activities/live/agenda/item_types/election/election_post_card/en.yml": 92053,
	"./admin/activities/live/agenda/item_types/election/election_post_contact_card/da.yml": 39140,
	"./admin/activities/live/agenda/item_types/election/election_post_contact_card/en.yml": 41452,
	"./admin/activities/live/agenda/item_types/election/index/da.yml": 36128,
	"./admin/activities/live/agenda/item_types/election/index/en.yml": 39936,
	"./admin/activities/live/agenda/item_types/proposal/proposal_card/da.yml": 91364,
	"./admin/activities/live/agenda/item_types/proposal/proposal_card/en.yml": 67948,
	"./admin/activities/live/agenda/item_types/speaker_list/actions_bar/next_speaker_button/da.yml": 98015,
	"./admin/activities/live/agenda/item_types/speaker_list/actions_bar/next_speaker_button/en.yml": 82807,
	"./admin/activities/live/agenda/item_types/speaker_list/da.yml": 35074,
	"./admin/activities/live/agenda/item_types/speaker_list/en.yml": 8494,
	"./admin/activities/live_nav/da.yml": 38526,
	"./admin/activities/live_nav/en.yml": 46258,
	"./admin/activities/nav/da.yml": 66811,
	"./admin/activities/nav/en.yml": 1003,
	"./admin/activities/participants/da.yml": 51624,
	"./admin/activities/participants/en.yml": 27256,
	"./admin/activities/participants/index/da.yml": 90379,
	"./admin/activities/participants/index/en.yml": 8411,
	"./admin/activities/politics/proposals/da.yml": 77609,
	"./admin/activities/politics/proposals/en.yml": 77997,
	"./admin/activities/surveys/da.yml": 75213,
	"./admin/activities/surveys/en.yml": 38793,
	"./admin/activities/table/da.yml": 210,
	"./admin/activities/table/en.yml": 3390,
	"./admin/activity_groups/create_card/da.yml": 36866,
	"./admin/activity_groups/create_card/en.yml": 38574,
	"./admin/activity_participant_type_rules/create_card/da.yml": 55484,
	"./admin/activity_participant_type_rules/create_card/en.yml": 69204,
	"./admin/activity_participant_type_rules/table/da.yml": 63823,
	"./admin/activity_participant_type_rules/table/en.yml": 27527,
	"./admin/activity_participants/expandable_content/da.yml": 95423,
	"./admin/activity_participants/expandable_content/en.yml": 80215,
	"./admin/activity_participants/index/da.yml": 53155,
	"./admin/activity_participants/index/en.yml": 32387,
	"./admin/activity_participants/invite/da.yml": 34192,
	"./admin/activity_participants/invite/en.yml": 53456,
	"./admin/activity_participants/requested_unregister/da.yml": 44474,
	"./admin/activity_participants/requested_unregister/en.yml": 15510,
	"./admin/activity_participants/table/da.yml": 59479,
	"./admin/activity_participants/table/en.yml": 86175,
	"./admin/activity_surveys/edit/da.yml": 16906,
	"./admin/activity_surveys/edit/en.yml": 83526,
	"./admin/activity_surveys/table/da.yml": 31882,
	"./admin/activity_surveys/table/en.yml": 82150,
	"./admin/agenda_item_element_speakers/create_card/da.yml": 24592,
	"./admin/agenda_item_element_speakers/create_card/en.yml": 53360,
	"./admin/agenda_item_element_speakers/table/da.yml": 6883,
	"./admin/agenda_item_element_speakers/table/en.yml": 36035,
	"./admin/agenda_item_elements/create_card/da.yml": 55710,
	"./admin/agenda_item_elements/create_card/en.yml": 63442,
	"./admin/agenda_items/create_card/da.yml": 57195,
	"./admin/agenda_items/create_card/en.yml": 38491,
	"./admin/agendas/create_card/da.yml": 77005,
	"./admin/agendas/create_card/en.yml": 86665,
	"./admin/agendas/live_button/da.yml": 12185,
	"./admin/agendas/live_button/en.yml": 20125,
	"./admin/bank_accounts/bank_account_modal/da.yml": 17236,
	"./admin/bank_accounts/da.yml": 97407,
	"./admin/bank_accounts/en.yml": 82199,
	"./admin/bank_accounts/table/da.yml": 89892,
	"./admin/bank_accounts/table/en.yml": 66476,
	"./admin/bundle_photo_product/create_card/da.yml": 89955,
	"./admin/bundle_photo_product/create_card/en.yml": 66691,
	"./admin/bundles/edit/da.yml": 58182,
	"./admin/bundles/edit/en.yml": 55690,
	"./admin/bundles/select/da.yml": 17098,
	"./admin/bundles/select/en.yml": 91270,
	"./admin/bundles/show/da.yml": 38531,
	"./admin/bundles/show/en.yml": 17763,
	"./admin/call_list_entities/table/da.yml": 98946,
	"./admin/call_list_entities/table/en.yml": 27502,
	"./admin/call_lists/call_mode/call_list_entity_carousel/da.yml": 15528,
	"./admin/call_lists/call_mode/call_list_entity_carousel/en.yml": 91160,
	"./admin/call_lists/call_mode/index/da.yml": 51964,
	"./admin/call_lists/call_mode/index/en.yml": 49332,
	"./admin/call_lists/edit/da.yml": 72127,
	"./admin/call_lists/edit/en.yml": 56919,
	"./admin/call_lists/index/da.yml": 88401,
	"./admin/call_lists/index/en.yml": 62053,
	"./admin/call_lists/show/call_list_carousel/index/da.yml": 35992,
	"./admin/call_lists/show/call_list_carousel/index/en.yml": 18248,
	"./admin/call_lists/show/table/da.yml": 93401,
	"./admin/call_lists/show/table/en.yml": 31965,
	"./admin/call_lists/table/da.yml": 51437,
	"./admin/call_lists/table/en.yml": 9513,
	"./admin/comments/da.yml": 35706,
	"./admin/comments/en.yml": 64214,
	"./admin/comments/expanded_content_partial/da.yml": 12414,
	"./admin/comments/expanded_content_partial/en.yml": 28050,
	"./admin/comments/index/da.yml": 73613,
	"./admin/comments/index/en.yml": 83273,
	"./admin/communication/bottom_bar/da.yml": 35672,
	"./admin/communication/bottom_bar/en.yml": 47720,
	"./admin/communication/index/da.yml": 98083,
	"./admin/communication/index/en.yml": 43587,
	"./admin/communication/templates/da.yml": 20064,
	"./admin/communication/templates/en.yml": 74560,
	"./admin/competition_surveys/edit/da.yml": 78188,
	"./admin/competition_surveys/edit/en.yml": 16964,
	"./admin/competition_surveys/surveys/da.yml": 90531,
	"./admin/competition_surveys/surveys/en.yml": 36643,
	"./admin/competitions/edit/da.yml": 32785,
	"./admin/competitions/edit/en.yml": 57413,
	"./admin/competitions/form/da.yml": 6851,
	"./admin/competitions/form/en.yml": 86083,
	"./admin/competitions/index/da.yml": 48899,
	"./admin/competitions/index/en.yml": 25635,
	"./admin/competitions/surveys/da.yml": 89576,
	"./admin/competitions/surveys/en.yml": 13624,
	"./admin/components/photo_session_csvs/table/da.yml": 12539,
	"./admin/components/photo_session_csvs/table/en.yml": 46731,
	"./admin/components/photos/index/bottom_bar/da.yml": 88309,
	"./admin/components/photos/index/bottom_bar/en.yml": 59233,
	"./admin/components/sheet_layout_boxes/form/da.yml": 68316,
	"./admin/components/sheet_layout_boxes/form/en.yml": 26343,
	"./admin/contact_associates/create_card/da.yml": 27082,
	"./admin/contact_associates/create_card/en.yml": 77350,
	"./admin/contact_group_contacts/create_modal/da.yml": 11591,
	"./admin/contact_group_contacts/create_modal/en.yml": 76207,
	"./admin/contact_relationships/edit/da.yml": 697,
	"./admin/contact_relationships/edit/en.yml": 53866,
	"./admin/contacts/anonymize_button/da.yml": 63149,
	"./admin/contacts/anonymize_button/en.yml": 72809,
	"./admin/contacts/convert_organization_to_person_button/da.yml": 33550,
	"./admin/contacts/convert_organization_to_person_button/en.yml": 26818,
	"./admin/contacts/edit/billing_contact/da.yml": 46565,
	"./admin/contacts/edit/billing_contact/en.yml": 57553,
	"./admin/contacts/edit/da.yml": 59286,
	"./admin/contacts/edit/email/da.yml": 90893,
	"./admin/contacts/edit/email/en.yml": 79593,
	"./admin/contacts/edit/en.yml": 49434,
	"./admin/contacts/edit/historical_data_card/da.yml": 95767,
	"./admin/contacts/edit/historical_data_card/en.yml": 6111,
	"./admin/contacts/edit/organization_content/da.yml": 39046,
	"./admin/contacts/edit/organization_content/en.yml": 41162,
	"./admin/contacts/edit/relationships/da.yml": 43206,
	"./admin/contacts/edit/relationships/en.yml": 40714,
	"./admin/contacts/edit/school_content/da.yml": 9833,
	"./admin/contacts/edit/school_content/en.yml": 39949,
	"./admin/contacts/edit/student_council_content/da.yml": 81828,
	"./admin/contacts/edit/student_council_content/en.yml": 27564,
	"./admin/contacts/edit/supplier_content/da.yml": 82025,
	"./admin/contacts/edit/supplier_content/en.yml": 12141,
	"./admin/contacts/index/bottom_bar/add_to_activity/da.yml": 24962,
	"./admin/contacts/index/bottom_bar/add_to_activity/en.yml": 86702,
	"./admin/contacts/index/bottom_bar/da.yml": 94366,
	"./admin/contacts/index/bottom_bar/en.yml": 93650,
	"./admin/contacts/index/da.yml": 95174,
	"./admin/contacts/index/en.yml": 45706,
	"./admin/contacts/index/expandable_content/da.yml": 97569,
	"./admin/contacts/index/expandable_content/en.yml": 50581,
	"./admin/contacts/index/filter_content/da.yml": 60667,
	"./admin/contacts/index/filter_content/en.yml": 34283,
	"./admin/contacts/index/old_nemoa_filter/da.yml": 55010,
	"./admin/contacts/index/old_nemoa_filter/en.yml": 56718,
	"./admin/contacts/label/da.yml": 73024,
	"./admin/contacts/label/en.yml": 96288,
	"./admin/contacts/link/da.yml": 95218,
	"./admin/contacts/link/en.yml": 63166,
	"./admin/contacts/merge/da.yml": 62174,
	"./admin/contacts/merge/en.yml": 65906,
	"./admin/contacts/relations/da.yml": 88695,
	"./admin/contacts/relations/en.yml": 15391,
	"./admin/contacts/show/create_user_modal/da.yml": 22976,
	"./admin/contacts/show/create_user_modal/en.yml": 93824,
	"./admin/contacts/show/da.yml": 8179,
	"./admin/contacts/show/economy_and_integrations/da.yml": 98640,
	"./admin/contacts/show/economy_and_integrations/en.yml": 27408,
	"./admin/contacts/show/en.yml": 45235,
	"./admin/contacts/show/historical_data_card/da.yml": 60236,
	"./admin/contacts/show/historical_data_card/en.yml": 59332,
	"./admin/contacts/show/memberships/add_subscription_card/da.yml": 19094,
	"./admin/contacts/show/memberships/add_subscription_card/en.yml": 92890,
	"./admin/contacts/show/nav/da.yml": 80373,
	"./admin/contacts/show/nav/en.yml": 51297,
	"./admin/contacts/show/organization_further_information_card/da.yml": 60294,
	"./admin/contacts/show/organization_further_information_card/en.yml": 27178,
	"./admin/contacts/show/organization_general_information_card/da.yml": 76856,
	"./admin/contacts/show/organization_general_information_card/en.yml": 51112,
	"./admin/contacts/show/person/surveys_nav/da.yml": 7703,
	"./admin/contacts/show/person/surveys_nav/en.yml": 65023,
	"./admin/contacts/show/person/user_teams/da.yml": 99540,
	"./admin/contacts/show/person/user_teams/en.yml": 9084,
	"./admin/contacts/show/person_general_information_card/da.yml": 43654,
	"./admin/contacts/show/person_general_information_card/en.yml": 18781,
	"./admin/contacts/show/realtions/da.yml": 71583,
	"./admin/contacts/show/realtions/en.yml": 72727,
	"./admin/contacts/show/relations/da.yml": 41125,
	"./admin/contacts/show/relations/en.yml": 3697,
	"./admin/contacts/show/school_information_card/da.yml": 28672,
	"./admin/contacts/show/school_information_card/en.yml": 35584,
	"./admin/contacts/show/student_council_information_card/da.yml": 48709,
	"./admin/contacts/show/student_council_information_card/en.yml": 11281,
	"./admin/contacts/show/uni_c/da.yml": 60188,
	"./admin/contacts/show/uni_c/en.yml": 57556,
	"./admin/contacts/show/user/da.yml": 24487,
	"./admin/contacts/show/user/en.yml": 19727,
	"./admin/contacts/status_select/da.yml": 31561,
	"./admin/contacts/status_select/en.yml": 15597,
	"./admin/contacts/update_number_of_students_from_csv/da.yml": 59994,
	"./admin/contacts/update_number_of_students_from_csv/en.yml": 68598,
	"./admin/economy/account_dimensions/da.yml": 32224,
	"./admin/economy/account_dimensions/en.yml": 39136,
	"./admin/economy/accounts/da.yml": 4453,
	"./admin/economy/accounts/en.yml": 15441,
	"./admin/economy/accounts/index/da.yml": 47074,
	"./admin/economy/accounts/index/en.yml": 20494,
	"./admin/economy/dimensions/da.yml": 38744,
	"./admin/economy/dimensions/en.yml": 13000,
	"./admin/economy/dimensions/index/da.yml": 73403,
	"./admin/economy/dimensions/index/en.yml": 30667,
	"./admin/economy/dimensions/locked_dimensions/da.yml": 68961,
	"./admin/economy/employees/da.yml": 27342,
	"./admin/economy/employees/en.yml": 80962,
	"./admin/economy/index/da.yml": 943,
	"./admin/economy/index/en.yml": 64647,
	"./admin/economy/invoices/da.yml": 95113,
	"./admin/economy/invoices/en.yml": 95501,
	"./admin/economy/nav/da.yml": 13186,
	"./admin/economy/nav/en.yml": 58094,
	"./admin/economy/subscription_renewal_generations/choose_plan_modal/da.yml": 35859,
	"./admin/economy/subscription_renewal_generations/choose_plan_modal/en.yml": 47443,
	"./admin/economy/subscription_renewal_generations/da.yml": 49275,
	"./admin/economy/subscription_renewal_generations/en.yml": 67115,
	"./admin/election_posts/table/da.yml": 15124,
	"./admin/election_posts/table/en.yml": 82140,
	"./admin/element_feedback/da.yml": 42266,
	"./admin/element_feedback/en.yml": 96950,
	"./admin/elements/edit/da.yml": 93734,
	"./admin/elements/edit/en.yml": 60618,
	"./admin/elements/show/da.yml": 56259,
	"./admin/elements/show/en.yml": 1763,
	"./admin/elements/table/da.yml": 35038,
	"./admin/elements/table/en.yml": 42770,
	"./admin/emails/admin_confirm_button/da.yml": 29439,
	"./admin/emails/admin_confirm_button/en.yml": 14231,
	"./admin/employee_prices/create_card/da.yml": 27991,
	"./admin/employee_prices/create_card/en.yml": 54687,
	"./admin/employee_prices/table/da.yml": 72800,
	"./admin/employee_prices/table/en.yml": 27296,
	"./admin/finance_dimension_values/table/da.yml": 63995,
	"./admin/finance_dimension_values/table/en.yml": 50987,
	"./admin/highscore_class_steps/edit/da.yml": 49078,
	"./admin/highscore_class_steps/edit/en.yml": 698,
	"./admin/highscore_class_steps/table/da.yml": 46190,
	"./admin/highscore_class_steps/table/en.yml": 99810,
	"./admin/highscore_communes/table/da.yml": 78867,
	"./admin/highscore_communes/table/en.yml": 90451,
	"./admin/highscore_competitions/table/da.yml": 32500,
	"./admin/highscore_competitions/table/en.yml": 42044,
	"./admin/highscore_generation_surveys/show/da.yml": 46879,
	"./admin/highscore_generation_surveys/show/en.yml": 38999,
	"./admin/highscore_generation_teams/table/da.yml": 33891,
	"./admin/highscore_generation_teams/table/en.yml": 26979,
	"./admin/highscore_generations/nav/da.yml": 79572,
	"./admin/highscore_generations/nav/en.yml": 46588,
	"./admin/highscore_generations/overall_highscore/da.yml": 45977,
	"./admin/highscore_generations/overall_highscore/en.yml": 60413,
	"./admin/highscore_generations/participants/da.yml": 38825,
	"./admin/highscore_generations/participants/en.yml": 50541,
	"./admin/highscore_generations/show/da.yml": 55846,
	"./admin/highscore_generations/show/en.yml": 57962,
	"./admin/highscore_regions/table/da.yml": 12143,
	"./admin/highscore_regions/table/en.yml": 45223,
	"./admin/highscores/communes/da.yml": 64939,
	"./admin/highscores/communes/en.yml": 46235,
	"./admin/highscores/competitions/da.yml": 60240,
	"./admin/highscores/competitions/en.yml": 79504,
	"./admin/highscores/edit/da.yml": 47756,
	"./admin/highscores/edit/en.yml": 772,
	"./admin/highscores/excluded_users/da.yml": 62801,
	"./admin/highscores/excluded_users/en.yml": 52805,
	"./admin/highscores/index/da.yml": 35652,
	"./admin/highscores/index/en.yml": 12236,
	"./admin/highscores/nav/da.yml": 67209,
	"./admin/highscores/nav/en.yml": 78925,
	"./admin/highscores/organizations/da.yml": 58056,
	"./admin/highscores/organizations/en.yml": 82104,
	"./admin/highscores/regions/da.yml": 90861,
	"./admin/highscores/regions/en.yml": 84169,
	"./admin/highscores/show/da.yml": 493,
	"./admin/highscores/show/en.yml": 89193,
	"./admin/invoice_lines/create_card/da.yml": 46691,
	"./admin/invoice_lines/create_card/en.yml": 92195,
	"./admin/invoice_lines/table/da.yml": 20268,
	"./admin/invoice_lines/table/en.yml": 41220,
	"./admin/invoices/bottom_bar/da.yml": 88412,
	"./admin/invoices/bottom_bar/en.yml": 85780,
	"./admin/invoices/create_card/da.yml": 50952,
	"./admin/invoices/create_card/en.yml": 75000,
	"./admin/invoices/edit/da.yml": 27485,
	"./admin/invoices/edit/en.yml": 31865,
	"./admin/invoices/expandable_content/da.yml": 20243,
	"./admin/invoices/expandable_content/en.yml": 40947,
	"./admin/invoices/link/da.yml": 32421,
	"./admin/invoices/link/en.yml": 94993,
	"./admin/invoices/show/da.yml": 89100,
	"./admin/invoices/show/en.yml": 27876,
	"./admin/invoices/table/da.yml": 42971,
	"./admin/invoices/table/en.yml": 235,
	"./admin/layout/bottom_bar/pagination/da.yml": 51035,
	"./admin/layout/bottom_bar/pagination/en.yml": 85227,
	"./admin/layout/da.yml": 65826,
	"./admin/layout/en.yml": 67534,
	"./admin/layout/slide_menu/da.yml": 71022,
	"./admin/layout/slide_menu/en.yml": 24642,
	"./admin/layout/slide_menu/index/da.yml": 71985,
	"./admin/layout/slide_menu/index/en.yml": 45637,
	"./admin/layout/top_menu/extended_search/da.yml": 33337,
	"./admin/layout/top_menu/extended_search/en.yml": 6653,
	"./admin/layout/top_menu/extended_search/group/da.yml": 77525,
	"./admin/layout/top_menu/extended_search/group/en.yml": 99585,
	"./admin/layout/top_menu/extended_search/group/rule/attribute_select/chooser/da.yml": 21030,
	"./admin/layout/top_menu/extended_search/group/rule/attribute_select/chooser/en.yml": 87914,
	"./admin/layout/top_menu/extended_search/group/rule/attribute_select/da.yml": 8032,
	"./admin/layout/top_menu/extended_search/group/rule/attribute_select/en.yml": 28192,
	"./admin/layout/top_menu/extended_search/group/rule/da.yml": 8508,
	"./admin/layout/top_menu/extended_search/group/rule/en.yml": 17556,
	"./admin/layout/top_menu/search_bar/da.yml": 25971,
	"./admin/layout/top_menu/search_bar/deleted_at_filter/da.yml": 10766,
	"./admin/layout/top_menu/search_bar/deleted_at_filter/en.yml": 6914,
	"./admin/layout/top_menu/search_bar/en.yml": 44179,
	"./admin/layout/top_menu/user_menu_item/menu/da.yml": 43684,
	"./admin/layout/top_menu/user_menu_item/menu/en.yml": 89420,
	"./admin/layout_bottom_bar/pagination/da.yml": 92811,
	"./admin/layout_bottom_bar/pagination/en.yml": 10843,
	"./admin/logs/card/da.yml": 88894,
	"./admin/logs/card/en.yml": 92626,
	"./admin/logs/details/reimbursement/update/da.yml": 3399,
	"./admin/logs/details/reimbursement/update/en.yml": 98639,
	"./admin/logs/details/update/da.yml": 90,
	"./admin/logs/details/update/en.yml": 54774,
	"./admin/logs/headers/create/da.yml": 19571,
	"./admin/logs/headers/create/en.yml": 31155,
	"./admin/logs/headers/update/da.yml": 59282,
	"./admin/logs/headers/update/en.yml": 78814,
	"./admin/logs/index/da.yml": 93420,
	"./admin/logs/index/en.yml": 62788,
	"./admin/logs/names/activity_participant/da.yml": 33462,
	"./admin/logs/names/activity_participant/en.yml": 23610,
	"./admin/logs/table/da.yml": 55404,
	"./admin/logs/table/en.yml": 60004,
	"./admin/messages/create_message_modal/da.yml": 63891,
	"./admin/messages/create_message_modal/en.yml": 65747,
	"./admin/messages/create_modal/da.yml": 77731,
	"./admin/messages/create_modal/en.yml": 54467,
	"./admin/messages/table/da.yml": 44947,
	"./admin/messages/table/en.yml": 25683,
	"./admin/navigations/index/da.yml": 35244,
	"./admin/navigations/index/en.yml": 34340,
	"./admin/navigations/my_location/da.yml": 60256,
	"./admin/navigations/my_location/en.yml": 67168,
	"./admin/navigations/show/da.yml": 46165,
	"./admin/navigations/show/en.yml": 17697,
	"./admin/order_lines/expandable_content/orderables/photo_sheet_product_order_line/da.yml": 1496,
	"./admin/order_lines/expandable_content/orderables/photo_sheet_product_order_line/en.yml": 92104,
	"./admin/order_lines/table/da.yml": 4580,
	"./admin/order_lines/table/en.yml": 42079,
	"./admin/orders/bottom_bar/da.yml": 74043,
	"./admin/orders/bottom_bar/en.yml": 31307,
	"./admin/orders/cancel_button/da.yml": 18393,
	"./admin/orders/cancel_button/en.yml": 91709,
	"./admin/orders/create_shipments_in_workplace_button/da.yml": 45888,
	"./admin/orders/create_shipments_in_workplace_button/en.yml": 52800,
	"./admin/orders/finish_process_button/da.yml": 73608,
	"./admin/orders/finish_process_button/en.yml": 91768,
	"./admin/orders/generate_file_button/da.yml": 57125,
	"./admin/orders/generate_file_button/en.yml": 68113,
	"./admin/orders/generate_file_for_orders_in_workplace_button/da.yml": 46942,
	"./admin/orders/generate_file_for_orders_in_workplace_button/en.yml": 62578,
	"./admin/orders/generate_packing_slips_for_orders_in_workplace_button/da.yml": 79209,
	"./admin/orders/generate_packing_slips_for_orders_in_workplace_button/en.yml": 31706,
	"./admin/orders/index/da.yml": 47894,
	"./admin/orders/index/en.yml": 62554,
	"./admin/orders/order_lines/da.yml": 25062,
	"./admin/orders/order_lines/en.yml": 43530,
	"./admin/orders/process_button/da.yml": 65480,
	"./admin/orders/process_button/en.yml": 89528,
	"./admin/orders/show/da.yml": 75427,
	"./admin/orders/show/en.yml": 37891,
	"./admin/orders/statistics_modal/da.yml": 66412,
	"./admin/orders/statistics_modal/en.yml": 52503,
	"./admin/orders/table/da.yml": 35326,
	"./admin/orders/table/en.yml": 50962,
	"./admin/organizations/edit/da.yml": 10105,
	"./admin/organizations/edit/en.yml": 48669,
	"./admin/organizations/index/da.yml": 80411,
	"./admin/organizations/index/en.yml": 37675,
	"./admin/organizations/show/da.yml": 95280,
	"./admin/organizations/show/en.yml": 14544,
	"./admin/people/table/da.yml": 91532,
	"./admin/people/table/en.yml": 60900,
	"./admin/person_roles/create_for_contacts_modal/da.yml": 58526,
	"./admin/person_roles/create_for_contacts_modal/en.yml": 66258,
	"./admin/photo_colors/create_card/da.yml": 6265,
	"./admin/photo_colors/create_card/en.yml": 44829,
	"./admin/photo_colors/select/da.yml": 64990,
	"./admin/photo_colors/select/en.yml": 68722,
	"./admin/photo_products/resource_select/da.yml": 56727,
	"./admin/photo_products/resource_select/en.yml": 83423,
	"./admin/photo_products/table/da.yml": 25490,
	"./admin/photo_products/table/en.yml": 77086,
	"./admin/photo_qualities/create_card/da.yml": 16690,
	"./admin/photo_qualities/create_card/en.yml": 84638,
	"./admin/photo_qualities/select/da.yml": 76403,
	"./admin/photo_qualities/select/en.yml": 87987,
	"./admin/photo_session_group_contacts/table/da.yml": 5586,
	"./admin/photo_session_group_contacts/table/en.yml": 13214,
	"./admin/photo_sessions/actions_bar/da.yml": 86634,
	"./admin/photo_sessions/actions_bar/en.yml": 44454,
	"./admin/photo_sessions/bottom_bar/da.yml": 996,
	"./admin/photo_sessions/bottom_bar/en.yml": 26604,
	"./admin/photo_sessions/nav/da.yml": 47234,
	"./admin/photo_sessions/nav/en.yml": 8974,
	"./admin/photo_sessions/row/da.yml": 45471,
	"./admin/photo_sessions/row/en.yml": 34263,
	"./admin/photo_sessions/show/index/da.yml": 53207,
	"./admin/photo_sessions/show/index/en.yml": 96735,
	"./admin/photo_sessions/split_view/da.yml": 85097,
	"./admin/photo_sessions/split_view/en.yml": 96813,
	"./admin/photo_sessions/table/da.yml": 89443,
	"./admin/photo_sessions/table/en.yml": 35555,
	"./admin/photo_sessions/tree/da.yml": 84789,
	"./admin/photo_sessions/tree/en.yml": 72673,
	"./admin/photo_sessions/upload_csv_modal/index/da.yml": 35762,
	"./admin/photo_sessions/upload_csv_modal/index/en.yml": 59742,
	"./admin/photo_sheet_product_sheet_layouts/create_card/da.yml": 94640,
	"./admin/photo_sheet_product_sheet_layouts/create_card/en.yml": 97552,
	"./admin/photo_sheet_products/edit/da.yml": 56282,
	"./admin/photo_sheet_products/edit/en.yml": 34262,
	"./admin/photo_sheet_products/select/da.yml": 32054,
	"./admin/photo_sheet_products/select/en.yml": 83674,
	"./admin/photo_types/create_card/da.yml": 69734,
	"./admin/photo_types/create_card/en.yml": 67242,
	"./admin/photo_types/select/da.yml": 64199,
	"./admin/photo_types/select/en.yml": 28815,
	"./admin/photos/add_photo_type_to_photos_in_workplace_modal/da.yml": 73050,
	"./admin/photos/add_photo_type_to_photos_in_workplace_modal/en.yml": 27734,
	"./admin/photos/canvas/da.yml": 37574,
	"./admin/photos/canvas/en.yml": 56042,
	"./admin/photos/create_card/da.yml": 72069,
	"./admin/photos/create_card/en.yml": 83057,
	"./admin/photos/table/da.yml": 26126,
	"./admin/photos/table/en.yml": 96098,
	"./admin/photos/upload_card/da.yml": 98474,
	"./admin/photos/upload_card/en.yml": 95366,
	"./admin/plans/edit/da.yml": 38117,
	"./admin/plans/edit/en.yml": 84337,
	"./admin/plans/show/da.yml": 71652,
	"./admin/plans/show/en.yml": 48236,
	"./admin/plans/subscriptions/da.yml": 5269,
	"./admin/plans/subscriptions/en.yml": 27329,
	"./admin/plans/table/da.yml": 93811,
	"./admin/plans/table/en.yml": 95667,
	"./admin/products/select/da.yml": 61065,
	"./admin/products/select/en.yml": 72781,
	"./admin/products/show/da.yml": 42556,
	"./admin/products/show/en.yml": 39924,
	"./admin/reimbursement/table/da.yml": 40907,
	"./admin/reimbursement/table/en.yml": 22203,
	"./admin/reimbursement_attachments/expandable_content/da.yml": 94608,
	"./admin/reimbursement_attachments/expandable_content/description/da.yml": 32673,
	"./admin/reimbursement_attachments/expandable_content/description/en.yml": 81013,
	"./admin/reimbursement_attachments/expandable_content/en.yml": 80,
	"./admin/reimbursement_attachments/table/da.yml": 39066,
	"./admin/reimbursement_attachments/table/en.yml": 51222,
	"./admin/reimbursements/attachments/da.yml": 92432,
	"./admin/reimbursements/attachments/en.yml": 7696,
	"./admin/reimbursements/bottom_bar/da.yml": 33799,
	"./admin/reimbursements/bottom_bar/en.yml": 98415,
	"./admin/reimbursements/expense/da.yml": 74938,
	"./admin/reimbursements/expense/en.yml": 29622,
	"./admin/reimbursements/expense_sum/index/da.yml": 30453,
	"./admin/reimbursements/expense_sum/index/en.yml": 1985,
	"./admin/reimbursements/index/da.yml": 73650,
	"./admin/reimbursements/index/en.yml": 25246,
	"./admin/reimbursements/nav/da.yml": 78451,
	"./admin/reimbursements/nav/en.yml": 90035,
	"./admin/reimbursements/process/da.yml": 86651,
	"./admin/reimbursements/process/en.yml": 89995,
	"./admin/reimbursements/time/da.yml": 6687,
	"./admin/reimbursements/time/en.yml": 95479,
	"./admin/reimbursements/travel/da.yml": 38794,
	"./admin/reimbursements/travel/en.yml": 96614,
	"./admin/reimbursements/travel_sum/index/da.yml": 69093,
	"./admin/reimbursements/travel_sum/index/en.yml": 80081,
	"./admin/required_metadata/card/da.yml": 52278,
	"./admin/required_metadata/card/en.yml": 3898,
	"./admin/role_abilities/edit/da.yml": 45206,
	"./admin/role_abilities/edit/en.yml": 80474,
	"./admin/role_abilities/lock_icon/da.yml": 5091,
	"./admin/role_abilities/lock_icon/en.yml": 50595,
	"./admin/role_ability_groups/lock_icon/da.yml": 94712,
	"./admin/role_ability_groups/lock_icon/en.yml": 68968,
	"./admin/roles/abilities/da.yml": 3992,
	"./admin/roles/abilities/en.yml": 94600,
	"./admin/roles/ability_groups/da.yml": 99501,
	"./admin/roles/ability_groups/en.yml": 88201,
	"./admin/roles/edit/da.yml": 57822,
	"./admin/roles/edit/en.yml": 57106,
	"./admin/roles/show/da.yml": 71659,
	"./admin/roles/show/en.yml": 73339,
	"./admin/routes/contact_relationships/edit/da.yml": 97534,
	"./admin/routes/contact_relationships/edit/en.yml": 13170,
	"./admin/routes/webshop/photo_products/da.yml": 31841,
	"./admin/routes/webshop/photo_products/en.yml": 96533,
	"./admin/routes/webshop/tenant_photo_products/da.yml": 83088,
	"./admin/routes/webshop/tenant_photo_products/en.yml": 11856,
	"./admin/school_classes/index/da.yml": 60348,
	"./admin/school_classes/index/en.yml": 85748,
	"./admin/school_classes/table/da.yml": 20412,
	"./admin/school_classes/table/en.yml": 17172,
	"./admin/school_years/index/da.yml": 55018,
	"./admin/school_years/index/en.yml": 51910,
	"./admin/sending_rules/create_card/da.yml": 95378,
	"./admin/sending_rules/create_card/en.yml": 3006,
	"./admin/sending_rules/table/da.yml": 733,
	"./admin/sending_rules/table/en.yml": 37465,
	"./admin/sheet_layout_boxes/edit_modal/edit_box_icon/da.yml": 32446,
	"./admin/sheet_layout_boxes/edit_modal/edit_box_icon/en.yml": 40178,
	"./admin/sheet_layouts/create_card/da.yml": 603,
	"./admin/sheet_layouts/create_card/en.yml": 57867,
	"./admin/sheet_layouts/select/da.yml": 15424,
	"./admin/sheet_layouts/select/en.yml": 13203,
	"./admin/sheet_layouts/show/da.yml": 24525,
	"./admin/sheet_layouts/show/duplicate_box_icon/da.yml": 42919,
	"./admin/sheet_layouts/show/duplicate_box_icon/en.yml": 23887,
	"./admin/sheet_layouts/show/en.yml": 34185,
	"./admin/sheet_layouts/show/remove_box_icon/da.yml": 58732,
	"./admin/sheet_layouts/show/remove_box_icon/en.yml": 11748,
	"./admin/sheet_layouts_boxes/form/edit_box_icon/da.yml": 22949,
	"./admin/sheet_layouts_boxes/form/edit_box_icon/en.yml": 33937,
	"./admin/sheet_sizes/create_card/da.yml": 59222,
	"./admin/sheet_sizes/create_card/en.yml": 27802,
	"./admin/sheet_sizes/select/da.yml": 50647,
	"./admin/sheet_sizes/select/en.yml": 60991,
	"./admin/show_box_attributes/form/da.yml": 13332,
	"./admin/show_box_attributes/form/en.yml": 80348,
	"./admin/show_boxes/form/da.yml": 88478,
	"./admin/show_boxes/form/en.yml": 96210,
	"./admin/show_boxes/partial/attribute/da.yml": 46734,
	"./admin/show_boxes/partial/attribute/en.yml": 23650,
	"./admin/show_boxes/partial/box/da.yml": 99023,
	"./admin/show_boxes/partial/box/en.yml": 79079,
	"./admin/show_boxes/partial/da.yml": 80309,
	"./admin/show_boxes/partial/en.yml": 68193,
	"./admin/steps/da.yml": 319,
	"./admin/steps/edit/da.yml": 71404,
	"./admin/steps/edit/en.yml": 70500,
	"./admin/steps/element/da.yml": 30496,
	"./admin/steps/element/en.yml": 84992,
	"./admin/steps/element_feedback/da.yml": 22954,
	"./admin/steps/element_feedback/en.yml": 36198,
	"./admin/steps/element_feedback_option/da.yml": 14398,
	"./admin/steps/element_feedback_option/en.yml": 14578,
	"./admin/steps/elements/da.yml": 6249,
	"./admin/steps/elements/en.yml": 17965,
	"./admin/steps/en.yml": 92439,
	"./admin/steps/show/da.yml": 15341,
	"./admin/steps/show/en.yml": 73417,
	"./admin/steps/table/da.yml": 63204,
	"./admin/steps/table/en.yml": 8940,
	"./admin/student_council_memberships/edit/da.yml": 75970,
	"./admin/student_council_memberships/edit/en.yml": 4526,
	"./admin/subjects/select/da.yml": 95814,
	"./admin/subjects/select/en.yml": 14282,
	"./admin/subscription_periods/table/da.yml": 44867,
	"./admin/subscription_periods/table/en.yml": 24099,
	"./admin/subscription_renewal_generations/show/da.yml": 79070,
	"./admin/subscription_renewal_generations/show/en.yml": 82802,
	"./admin/subscription_renewal_generations/table/da.yml": 91185,
	"./admin/subscription_renewal_generations/table/en.yml": 73285,
	"./admin/subscriptions/show/da.yml": 59710,
	"./admin/subscriptions/show/en.yml": 76242,
	"./admin/subscriptions/table/da.yml": 54065,
	"./admin/subscriptions/table/en.yml": 27717,
	"./admin/supplier_supported_photo_qualities/create_card/da.yml": 39104,
	"./admin/supplier_supported_photo_qualities/create_card/en.yml": 62368,
	"./admin/supplier_supported_sheets/create_card/da.yml": 51430,
	"./admin/supplier_supported_sheets/create_card/en.yml": 18314,
	"./admin/suppliers/select/da.yml": 63810,
	"./admin/suppliers/select/en.yml": 37230,
	"./admin/survey_judges/row/da.yml": 69732,
	"./admin/survey_judges/row/en.yml": 15468,
	"./admin/surveys/activation_button/da.yml": 46561,
	"./admin/surveys/activation_button/en.yml": 11253,
	"./admin/surveys/edit/da.yml": 86008,
	"./admin/surveys/edit/en.yml": 14408,
	"./admin/surveys/index/da.yml": 2808,
	"./admin/surveys/index/en.yml": 31208,
	"./admin/surveys/nav/da.yml": 15829,
	"./admin/surveys/nav/en.yml": 86753,
	"./admin/surveys/show/da.yml": 83537,
	"./admin/surveys/show/en.yml": 8165,
	"./admin/surveys/survey_details/da.yml": 47811,
	"./admin/surveys/survey_details/en.yml": 76963,
	"./admin/surveys/survey_steps/da.yml": 86602,
	"./admin/surveys/survey_steps/en.yml": 44422,
	"./admin/surveys/table/da.yml": 28840,
	"./admin/surveys/table/en.yml": 47000,
	"./admin/taggings/taggable/da.yml": 10060,
	"./admin/taggings/taggable/en.yml": 9156,
	"./admin/taggings/taggable/form/da.yml": 6391,
	"./admin/taggings/taggable/form/en.yml": 49919,
	"./admin/tags/workplace_merge_button/da.yml": 76594,
	"./admin/tags/workplace_merge_button/en.yml": 96126,
	"./admin/team_surveys/bottom_bar/da.yml": 98611,
	"./admin/team_surveys/bottom_bar/en.yml": 16819,
	"./admin/team_surveys/index/da.yml": 48174,
	"./admin/team_surveys/index/en.yml": 44322,
	"./admin/team_surveys/show/da.yml": 80795,
	"./admin/team_surveys/show/en.yml": 38059,
	"./admin/team_surveys/show/user_step/da.yml": 32078,
	"./admin/team_surveys/show/user_step/en.yml": 85698,
	"./admin/team_surveys/table/da.yml": 53302,
	"./admin/team_surveys/table/en.yml": 27098,
	"./admin/team_users/edit/da.yml": 17499,
	"./admin/team_users/edit/en.yml": 35339,
	"./admin/team_users/show/da.yml": 76782,
	"./admin/team_users/show/en.yml": 30402,
	"./admin/teams/edit/da.yml": 47823,
	"./admin/teams/edit/en.yml": 19431,
	"./admin/teams/index/da.yml": 59361,
	"./admin/teams/index/en.yml": 7701,
	"./admin/teams/show/da.yml": 91786,
	"./admin/teams/show/en.yml": 23878,
	"./admin/templates/create_card/da.yml": 48543,
	"./admin/templates/create_card/en.yml": 33335,
	"./admin/tenant_domains/row/da.yml": 24369,
	"./admin/tenant_domains/row/en.yml": 79173,
	"./admin/tenant_domains/select/da.yml": 36307,
	"./admin/tenant_domains/select/en.yml": 33395,
	"./admin/tenant_photo_products/create_card/da.yml": 50216,
	"./admin/tenant_photo_products/create_card/en.yml": 74264,
	"./admin/tenant_photo_products/visible_in_shop/da.yml": 21314,
	"./admin/tenant_photo_products/visible_in_shop/en.yml": 83054,
	"./admin/tenants/create_card/da.yml": 18949,
	"./admin/tenants/create_card/en.yml": 29937,
	"./admin/tenants/integrations/bambora/da.yml": 29308,
	"./admin/tenants/integrations/bambora/en.yml": 38356,
	"./admin/tenants/integrations/inventio/da.yml": 84882,
	"./admin/tenants/integrations/inventio/en.yml": 92510,
	"./admin/tenants/integrations/nav/da.yml": 65019,
	"./admin/tenants/integrations/nav/en.yml": 22283,
	"./admin/tenants/integrations/shipmondo/da.yml": 99095,
	"./admin/tenants/integrations/shipmondo/en.yml": 40063,
	"./admin/tenants/nav/da.yml": 36783,
	"./admin/tenants/nav/en.yml": 69863,
	"./admin/tenants/setup/da.yml": 49871,
	"./admin/tenants/setup/en.yml": 82951,
	"./admin/toggle_eye_button/da.yml": 81599,
	"./admin/toggle_eye_button/en.yml": 70391,
	"./admin/user_elements/answer/da.yml": 45440,
	"./admin/user_elements/answer/en.yml": 52352,
	"./admin/user_elements/edit/da.yml": 52282,
	"./admin/user_elements/edit/en.yml": 30262,
	"./admin/users/edit/da.yml": 22313,
	"./admin/users/edit/en.yml": 6349,
	"./admin/users/index/da.yml": 21291,
	"./admin/users/index/en.yml": 22971,
	"./admin/users/passwords/edit/da.yml": 18946,
	"./admin/users/passwords/edit/en.yml": 92366,
	"./admin/users/passwords/new/da.yml": 78756,
	"./admin/users/passwords/new/en.yml": 4364,
	"./admin/users/show/da.yml": 60448,
	"./admin/users/show/en.yml": 14944,
	"./admin/workplaces/bottom_bar/add_relationship_to_workplace_modal/da.yml": 67903,
	"./admin/workplaces/bottom_bar/add_relationship_to_workplace_modal/en.yml": 52695,
	"./admin/workplaces/bottom_bar/da.yml": 49671,
	"./admin/workplaces/bottom_bar/en.yml": 93327,
	"./admin/workplaces/bottom_bar/index/da.yml": 98924,
	"./admin/workplaces/bottom_bar/index/en.yml": 3524,
	"./agenda_item_elements/edit/audio/da.yml": 52238,
	"./agenda_item_elements/edit/audio/en.yml": 29154,
	"./agenda_item_elements/edit/document/da.yml": 24857,
	"./agenda_item_elements/edit/document/en.yml": 79773,
	"./agenda_item_elements/edit/image/da.yml": 96105,
	"./agenda_item_elements/edit/image/en.yml": 42573,
	"./agendas/actions_bar/da.yml": 60075,
	"./agendas/actions_bar/en.yml": 28571,
	"./agendas/live/da.yml": 46116,
	"./agendas/live/en.yml": 91852,
	"./bank_accounts/account_type_select/da.yml": 19505,
	"./bank_accounts/account_type_select/en.yml": 1605,
	"./block_ui/da.yml": 76792,
	"./block_ui/en.yml": 5192,
	"./buttons/table_expand/da.yml": 60071,
	"./buttons/table_expand/en.yml": 3727,
	"./classSteps/select/da.yml": 47896,
	"./classSteps/select/en.yml": 80296,
	"./competitions/choose_survey/da.yml": 77419,
	"./competitions/choose_survey/en.yml": 95451,
	"./competitions/choose_team/da.yml": 45076,
	"./competitions/choose_team/en.yml": 28444,
	"./competitions/choose_team_type/da.yml": 24401,
	"./competitions/choose_team_type/en.yml": 32677,
	"./competitions/index/da.yml": 5131,
	"./competitions/index/en.yml": 89979,
	"./competitions/show/da.yml": 76512,
	"./competitions/show/en.yml": 99776,
	"./competitions_choose_team/da.yml": 5092,
	"./competitions_choose_team/en.yml": 30700,
	"./components/responsive_nav/da.yml": 79497,
	"./components/responsive_nav/en.yml": 71533,
	"./confirm_dialog/da.yml": 52497,
	"./confirm_dialog/en.yml": 18245,
	"./contact_merge_requests/confirm_merge_request/da.yml": 2508,
	"./contact_merge_requests/confirm_merge_request/en.yml": 23460,
	"./contact_merge_requests/merge_request/da.yml": 97023,
	"./contact_merge_requests/merge_request/en.yml": 81815,
	"./contacts/select/da.yml": 66962,
	"./contacts/select/en.yml": 86494,
	"./election/school_elections/new/da.yml": 19578,
	"./election/school_elections/new/en.yml": 28182,
	"./element_types/da.yml": 57578,
	"./element_types/en.yml": 73318,
	"./feedback_assignments/show/da.yml": 32206,
	"./feedback_assignments/show/en.yml": 85826,
	"./feedback_steps/da.yml": 45207,
	"./feedback_steps/dropdown/da.yml": 66585,
	"./feedback_steps/dropdown/en.yml": 39901,
	"./feedback_steps/edit/da.yml": 96052,
	"./feedback_steps/edit/en.yml": 5596,
	"./feedback_steps/en.yml": 88735,
	"./flash_message/da.yml": 16146,
	"./flash_message/en.yml": 35678,
	"./forms/attachment_input/da.yml": 14758,
	"./forms/attachment_input/en.yml": 12266,
	"./forms/image_input/da.yml": 27630,
	"./forms/image_input/en.yml": 81250,
	"./global/da.yml": 99344,
	"./global/en.yml": 70051,
	"./jobler/job_status/da.yml": 19937,
	"./jobler/job_status/en.yml": 72949,
	"./layout/da.yml": 82074,
	"./layout/en.yml": 7030,
	"./layout/impersonation_banner/da.yml": 13920,
	"./layout/impersonation_banner/en.yml": 17728,
	"./layout/no_access/da.yml": 63095,
	"./layout/no_access/en.yml": 73439,
	"./layout/not_found/da.yml": 70731,
	"./layout/not_found/en.yml": 72411,
	"./layout/require_two_factor_authentication_proxy/da.yml": 52223,
	"./layout/require_two_factor_authentication_proxy/en.yml": 37015,
	"./layout/top_menu/user_meun_item/menu/da.yml": 28142,
	"./layout/top_menu/user_meun_item/menu/en.yml": 24290,
	"./layout/top_nav/da.yml": 91568,
	"./layout/top_nav/en.yml": 10832,
	"./layout/top_nav/notifications_modal/da.yml": 99609,
	"./layout/top_nav/notifications_modal/en.yml": 56573,
	"./live_streaming_feeds/broadcaster/index/da.yml": 32071,
	"./live_streaming_feeds/broadcaster/index/en.yml": 96687,
	"./live_streaming_feeds/broadcaster/settings/da.yml": 89748,
	"./live_streaming_feeds/broadcaster/settings/en.yml": 56764,
	"./live_streaming_feeds/viewer/da.yml": 20134,
	"./live_streaming_feeds/viewer/en.yml": 45930,
	"./merfoto/albums/index/da.yml": 23684,
	"./merfoto/albums/index/en.yml": 49292,
	"./merfoto/basket/basket_item_card/index/da.yml": 27898,
	"./merfoto/basket/basket_item_card/index/en.yml": 82582,
	"./merfoto/basket/da.yml": 21245,
	"./merfoto/basket/destroy_order_line_button/da.yml": 9599,
	"./merfoto/basket/destroy_order_line_button/en.yml": 98391,
	"./merfoto/basket/en.yml": 20889,
	"./merfoto/basket/quantity/da.yml": 80059,
	"./merfoto/basket/quantity/en.yml": 83403,
	"./merfoto/basket/unique_photos_label/da.yml": 17866,
	"./merfoto/basket/unique_photos_label/en.yml": 92038,
	"./merfoto/checkout/completed/da.yml": 99065,
	"./merfoto/checkout/completed/en.yml": 37629,
	"./merfoto/checkout/confirm/da.yml": 74068,
	"./merfoto/checkout/confirm/en.yml": 99964,
	"./merfoto/checkout/customer_information/da.yml": 41597,
	"./merfoto/checkout/customer_information/en.yml": 29625,
	"./merfoto/checkout/delivery/da.yml": 98708,
	"./merfoto/checkout/delivery/en.yml": 89020,
	"./merfoto/checkout/navbar/da.yml": 38790,
	"./merfoto/checkout/navbar/en.yml": 40906,
	"./merfoto/checkout/payment/da.yml": 69818,
	"./merfoto/checkout/payment/en.yml": 47798,
	"./merfoto/components/order_lines/edit/resources/bundle/da.yml": 65748,
	"./merfoto/components/order_lines/edit/resources/bundle/en.yml": 75292,
	"./merfoto/components/sheet-layouts/presentation/da.yml": 47890,
	"./merfoto/components/sheet-layouts/presentation/en.yml": 15838,
	"./merfoto/downloads/da.yml": 38600,
	"./merfoto/downloads/en.yml": 81880,
	"./merfoto/layout/footer/da.yml": 56437,
	"./merfoto/layout/footer/en.yml": 27361,
	"./merfoto/layout/footer/index/da.yml": 37618,
	"./merfoto/layout/footer/index/en.yml": 45246,
	"./merfoto/layout/index/da.yml": 92638,
	"./merfoto/layout/index/en.yml": 91922,
	"./merfoto/layout/top_bar/index/da.yml": 77696,
	"./merfoto/layout/top_bar/index/en.yml": 84608,
	"./merfoto/layout/top_bar/signed_in_user_button/menu_modal/da.yml": 54891,
	"./merfoto/layout/top_bar/signed_in_user_button/menu_modal/en.yml": 72923,
	"./merfoto/layout/topbar/index/da.yml": 49929,
	"./merfoto/layout/topbar/index/en.yml": 61645,
	"./merfoto/order_deliveries/delivery_methods/digital_download/options/da.yml": 16791,
	"./merfoto/order_deliveries/delivery_methods/digital_download/options/en.yml": 76671,
	"./merfoto/order_deliveries/delivery_methods/pick_up/index/da.yml": 51129,
	"./merfoto/order_deliveries/delivery_methods/pick_up/index/en.yml": 24445,
	"./merfoto/order_deliveries/delivery_methods/shipmondo/index/da.yml": 61595,
	"./merfoto/order_deliveries/delivery_methods/shipmondo/index/en.yml": 18859,
	"./merfoto/order_lines/edit/submit_image_button/da.yml": 4602,
	"./merfoto/order_lines/edit/submit_image_button/en.yml": 16758,
	"./merfoto/orders/da.yml": 12022,
	"./merfoto/orders/en.yml": 2170,
	"./merfoto/orders/table/da.yml": 84053,
	"./merfoto/orders/table/en.yml": 38625,
	"./merfoto/orders/total_with_delivery/da.yml": 65853,
	"./merfoto/orders/total_with_delivery/en.yml": 53881,
	"./merfoto/photo_session_group_contact_tokens/create_from_token_card/da.yml": 66139,
	"./merfoto/photo_session_group_contact_tokens/create_from_token_card/en.yml": 83979,
	"./merfoto/photo_session_group_contact_tokens/create_from_token_form/da.yml": 82271,
	"./merfoto/photo_session_group_contact_tokens/create_from_token_form/en.yml": 67063,
	"./merfoto/photo_session_group_contacts/select_album/da.yml": 90203,
	"./merfoto/photo_session_group_contacts/select_album/en.yml": 47467,
	"./merfoto/photo_session_groups/card/index/da.yml": 50577,
	"./merfoto/photo_session_groups/card/index/en.yml": 58853,
	"./merfoto/photo_session_groups/card/photo_card/da.yml": 70488,
	"./merfoto/photo_session_groups/card/photo_card/en.yml": 44744,
	"./merfoto/photo_sheet_product_order_lines/edit/da.yml": 97999,
	"./merfoto/photo_sheet_product_order_lines/edit/en.yml": 69607,
	"./merfoto/routes/albums/da.yml": 4806,
	"./merfoto/routes/albums/en.yml": 71690,
	"./merfoto/routes/welcome/da.yml": 21241,
	"./merfoto/routes/welcome/en.yml": 62090,
	"./merfoto/tenant_photo_products/add_to_basket_button/da.yml": 42651,
	"./merfoto/tenant_photo_products/add_to_basket_button/en.yml": 99915,
	"./merfoto/tenant_photo_products_with_photos/card/index/da.yml": 55898,
	"./merfoto/tenant_photo_products_with_photos/card/index/en.yml": 80854,
	"./merfoto/tenant_photo_products_with_photos/index/da.yml": 75841,
	"./merfoto/tenant_photo_products_with_photos/index/en.yml": 40533,
	"./merfoto/token/da.yml": 90108,
	"./merfoto/token/en.yml": 3828,
	"./merfoto/users/passwords/new/da.yml": 97697,
	"./merfoto/users/passwords/new/en.yml": 50485,
	"./merfoto/welcome/da.yml": 12709,
	"./merfoto/welcome/en.yml": 23697,
	"./merfoto/welcome_top_container/index/da.yml": 5294,
	"./merfoto/welcome_top_container/index/en.yml": 1442,
	"./models_table/add_column_button/da.yml": 66357,
	"./models_table/add_column_button/en.yml": 72065,
	"./models_table/columns_drop_down/da.yml": 19372,
	"./models_table/columns_drop_down/en.yml": 72388,
	"./navigations/index/da.yml": 97716,
	"./navigations/index/en.yml": 64732,
	"./navigations/show/da.yml": 44477,
	"./navigations/show/en.yml": 7385,
	"./nemoa/activities/elections/election/da.yml": 67543,
	"./nemoa/activities/elections/election/en.yml": 11071,
	"./nemoa/activities/index/card/participant_state_overlay/index/da.yml": 53450,
	"./nemoa/activities/index/card/participant_state_overlay/index/en.yml": 20070,
	"./nemoa/activities/mine/index/da.yml": 56225,
	"./nemoa/activities/mine/index/en.yml": 4565,
	"./nemoa/activities/nav/index/da.yml": 99717,
	"./nemoa/activities/nav/index/en.yml": 94353,
	"./nemoa/activities/required_metadata_proxy_with_surveys/da.yml": 56048,
	"./nemoa/activities/required_metadata_proxy_with_surveys/en.yml": 75312,
	"./nemoa/activities/show/elections/da.yml": 15755,
	"./nemoa/activities/show/elections/en.yml": 84251,
	"./nemoa/activities/show/elections/index/da.yml": 88592,
	"./nemoa/activities/show/elections/index/en.yml": 94064,
	"./nemoa/activities/show/index/da.yml": 7751,
	"./nemoa/activities/show/index/en.yml": 58959,
	"./nemoa/activities/show/live/da.yml": 95679,
	"./nemoa/activities/show/live/en.yml": 80471,
	"./nemoa/activities/show/nav/da.yml": 53434,
	"./nemoa/activities/show/nav/en.yml": 8118,
	"./nemoa/activities/show/politics/da.yml": 82830,
	"./nemoa/activities/show/politics/en.yml": 36450,
	"./nemoa/components/user_steps/element_types/question_sentence/da.yml": 50563,
	"./nemoa/components/user_steps/element_types/question_sentence/en.yml": 29795,
	"./nemoa/layout/slide_menu/index/da.yml": 14366,
	"./nemoa/layout/slide_menu/index/en.yml": 30002,
	"./nemoa/layout/top_menu/index/da.yml": 53312,
	"./nemoa/layout/top_menu/index/en.yml": 7808,
	"./nemoa/layout/top_menu/user_menu_item/index/da.yml": 85584,
	"./nemoa/layout/top_menu/user_menu_item/index/en.yml": 848,
	"./nemoa/required_metadata/required_metadata_proxy/da.yml": 54727,
	"./nemoa/required_metadata/required_metadata_proxy/en.yml": 66319,
	"./nemoa/user_steps/edit/da.yml": 58263,
	"./nemoa/user_steps/edit/en.yml": 18143,
	"./nemoa/users/edit/form/index/da.yml": 14304,
	"./nemoa/users/edit/form/index/en.yml": 68800,
	"./nemoa/users/passwords/new/da.yml": 17503,
	"./nemoa/users/passwords/new/en.yml": 6295,
	"./nemoa_select/da.yml": 72173,
	"./nemoa_select/en.yml": 81833,
	"./notifications/types/team_application_accepted/da.yml": 37817,
	"./notifications/types/team_application_accepted/en.yml": 76381,
	"./notifications/types/team_application_declined/da.yml": 47402,
	"./notifications/types/team_application_declined/en.yml": 79494,
	"./notifications/types/team_survey_started/da.yml": 89471,
	"./notifications/types/team_survey_started/en.yml": 81591,
	"./organizations/select/da.yml": 30661,
	"./organizations/select/en.yml": 41649,
	"./preview/da.yml": 21812,
	"./preview/en.yml": 31356,
	"./proposal_types/presenter_card/da.yml": 26390,
	"./proposal_types/presenter_card/en.yml": 94970,
	"./registrations/form/da.yml": 61669,
	"./registrations/form/en.yml": 7889,
	"./reimbursements/attachments/create_card/da.yml": 65404,
	"./reimbursements/attachments/create_card/en.yml": 74452,
	"./reimbursements/create_card/da.yml": 44537,
	"./reimbursements/create_card/en.yml": 52477,
	"./reimbursements/create_card/extended_form/save_and_request_approval_button/da.yml": 88917,
	"./reimbursements/create_card/extended_form/save_and_request_approval_button/en.yml": 59841,
	"./reimbursements/create_card/extended_form/save_button/da.yml": 39415,
	"./reimbursements/create_card/extended_form/save_button/en.yml": 49759,
	"./reimbursements/create_card/index/da.yml": 88246,
	"./reimbursements/create_card/index/en.yml": 56826,
	"./reimbursements/documents/da.yml": 27668,
	"./reimbursements/documents/en.yml": 53564,
	"./reimbursements/documents_button/carousel/da.yml": 76892,
	"./reimbursements/documents_button/carousel/en.yml": 85556,
	"./reimbursements/expenses/index/da.yml": 77888,
	"./reimbursements/expenses/index/en.yml": 81696,
	"./reimbursements/index/da.yml": 47162,
	"./reimbursements/index/en.yml": 25142,
	"./reimbursements/index/time_sum/da.yml": 51334,
	"./reimbursements/index/time_sum/en.yml": 31069,
	"./reimbursements/table/da.yml": 37298,
	"./reimbursements/table/en.yml": 44926,
	"./reimbursements/time/da.yml": 73063,
	"./reimbursements/time/en.yml": 16719,
	"./reimbursements/travel/index/da.yml": 11061,
	"./reimbursements/travel/index/en.yml": 82593,
	"./roles/select/da.yml": 10730,
	"./roles/select/en.yml": 54969,
	"./save_modes/da.yml": 36806,
	"./save_modes/en.yml": 34314,
	"./school_classes/select/da.yml": 35808,
	"./school_classes/select/en.yml": 39616,
	"./sessions/new/da.yml": 39204,
	"./sessions/new/en.yml": 64812,
	"./sessions/new/index/da.yml": 46055,
	"./sessions/new/index/en.yml": 27023,
	"./sessions/new/one_time_password_prompt/da.yml": 95594,
	"./sessions/new/one_time_password_prompt/en.yml": 69766,
	"./sessions/new/uni_login_image_button/da.yml": 12998,
	"./sessions/new/uni_login_image_button/en.yml": 79882,
	"./shared/create_card/da.yml": 9889,
	"./shared/create_card/en.yml": 62901,
	"./shared/da.yml": 40517,
	"./shared/en.yml": 51505,
	"./shared/preview/da.yml": 7258,
	"./shared/preview/en.yml": 19414,
	"./shared/preview/index/da.yml": 85037,
	"./shared/preview/index/en.yml": 78345,
	"./shared/state_selector/da.yml": 29609,
	"./shared/state_selector/en.yml": 37997,
	"./shared/table/index/da.yml": 44045,
	"./shared/table/index/en.yml": 7625,
	"./shared/table/row/da.yml": 68741,
	"./shared/table/row/en.yml": 19633,
	"./shared/tree/index/da.yml": 76985,
	"./shared/tree/index/en.yml": 33949,
	"./shared/tree/node/da.yml": 28059,
	"./shared/tree/node/en.yml": 45899,
	"./sheet_layouts/presentation/index/da.yml": 48159,
	"./sheet_layouts/presentation/index/en.yml": 32951,
	"./steps/da.yml": 60983,
	"./steps/en.yml": 4511,
	"./surveys/list_partial/da.yml": 82002,
	"./surveys/list_partial/en.yml": 1534,
	"./surveys/show/da.yml": 16441,
	"./surveys/show/en.yml": 89757,
	"./team_surveys/complete/da.yml": 63889,
	"./team_surveys/complete/en.yml": 45989,
	"./team_surveys/edit/da.yml": 27830,
	"./team_surveys/edit/en.yml": 80058,
	"./team_surveys/feedback_states/da.yml": 20876,
	"./team_surveys/feedback_states/en.yml": 73892,
	"./team_surveys/time_used/da.yml": 74117,
	"./team_surveys/time_used/en.yml": 36689,
	"./teams/edit/da.yml": 29127,
	"./teams/edit/en.yml": 72783,
	"./teams/selector/choose_team/da.yml": 89782,
	"./teams/selector/choose_team/en.yml": 88090,
	"./teams/show/da.yml": 69938,
	"./teams/show/en.yml": 77566,
	"./tenants/select/da.yml": 49762,
	"./tenants/select/en.yml": 23182,
	"./tenants/setup/da.yml": 33111,
	"./tenants/setup/en.yml": 76639,
	"./uni_logins/new/da.yml": 2896,
	"./uni_logins/new/en.yml": 22160,
	"./uni_logins/successful/da.yml": 51552,
	"./uni_logins/successful/en.yml": 74816,
	"./upload_button/index/da.yml": 43053,
	"./upload_button/index/en.yml": 6633,
	"./upload_button_with_preview/index/da.yml": 34363,
	"./upload_button_with_preview/index/en.yml": 37707,
	"./user_steps/edit/da.yml": 17672,
	"./user_steps/edit/en.yml": 93304,
	"./user_steps/element_types/question_dropdown/da.yml": 33805,
	"./user_steps/element_types/question_dropdown/en.yml": 43465,
	"./user_steps/element_types/question_file/index/da.yml": 18417,
	"./user_steps/element_types/question_file/index/en.yml": 73221,
	"./users/confirmation/da.yml": 19096,
	"./users/confirmation/en.yml": 1352,
	"./users/confirmation/index/da.yml": 44539,
	"./users/confirmation/index/en.yml": 62379,
	"./users/confirmation/new/da.yml": 51821,
	"./users/confirmation/new/en.yml": 40521,
	"./users/confirmations/new/da.yml": 41336,
	"./users/confirmations/new/en.yml": 73736,
	"./users/consent/index/da.yml": 49866,
	"./users/consent/index/en.yml": 24038,
	"./users/edit/form/da.yml": 18104,
	"./users/edit/form/en.yml": 50504,
	"./users/edit/form/index/da.yml": 85275,
	"./users/edit/form/index/en.yml": 58891,
	"./users/edit/form/relatives/da.yml": 28690,
	"./users/edit/form/relatives/en.yml": 84734,
	"./users/edit/form/two_factor_authentication/da.yml": 82678,
	"./users/edit/form/two_factor_authentication/en.yml": 34906,
	"./users/edit/school/da.yml": 43158,
	"./users/edit/school/en.yml": 95386,
	"./users/notifications/partial/da.yml": 69409,
	"./users/notifications/partial/en.yml": 34101,
	"./users/passwords/edit/da.yml": 41802,
	"./users/passwords/edit/en.yml": 38694,
	"./users/passwords/edit/index/da.yml": 74205,
	"./users/passwords/edit/index/en.yml": 53465,
	"./users/passwords/new/da.yml": 91740,
	"./users/passwords/new/en.yml": 17140,
	"./users/settings/da.yml": 25304,
	"./users/settings/en.yml": 7560
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70064;